import { useState } from 'react'
import dayjs from 'dayjs'
import styled from 'styled-components'

import useCookies from '@/shared/hooks/useCookies'
import useLockBodyScroll from '@/shared/hooks/useLockScroll'
import { PopupType } from '@/shared/types/api'
import { mediaMobile } from '@/styles/mediaQuery'

interface HomePopupProps {
  popUpData: PopupType
}

const IMG_BASE_URL = import.meta.env.VITE_APP_SERVER_IMG_URL

const HomePopup = ({ popUpData }: HomePopupProps) => {
  const cookie = useCookies()
  const [popOpen, setPopOpen] = useState(true)
  const popupCookie = cookie.get('popup')

  useLockBodyScroll(popOpen && !popupCookie)

  const handlecloseToday = () => {
    if (!popupCookie) {
      cookie.set('popup', 'home', 24 - dayjs(Date.now()).hour())
      setPopOpen(false)
    }
  }
  const handlecloseNow = () => {
    setPopOpen(false)
  }
  return (
    <>
      {popOpen && !popupCookie && (
        <HomePopupWrap className="wrap">
          <PopupContent className="content" $scale={Math.min(1, window.innerHeight / 603)}>
            <a href={popUpData.LinkPath} target="_blank" rel="noreferrer">
              <img src={`${IMG_BASE_URL}${popUpData.ImgPath}`} alt={popUpData.PopupTitle} />
            </a>
            <CloseButtonWrap>
              <TodayCloseButton onClick={handlecloseToday}>오늘 그만 보기</TodayCloseButton>
              <VerticalLine />
              <NowCloseButton onClick={handlecloseNow}>닫기</NowCloseButton>
            </CloseButtonWrap>
          </PopupContent>
        </HomePopupWrap>
      )}
    </>
  )
}

export default HomePopup

const HomePopupWrap = styled.div`
  z-index: 1000;
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.7);
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;

  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }

  ${mediaMobile} {
    padding-bottom: 16px;
  }
`

const PopupContent = styled.div<{ $scale: number }>`
  width: 420px;
  min-height: 170px;
  height: auto;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  overflow: hidden;
  transform: scale(${({ $scale }) => $scale});
  transform-origin: center center;

  @media all and (max-width: 540px) {
    width: 360px;
  }
  @media all and (max-width: 400px) {
    padding: 0 20px;
    width: 100%;
  }

  > a > img {
    width: 100%;
  }
`

const CloseButtonWrap = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 10px;
  gap: 10px;
  border-radius: 0 0 20px 20px;
  background-color: #f3f3f3;

  > button {
    flex: 1;
    padding: 10px 0;
    font-family: 'Noto Sans KR', sans-serif;
    font-size: 18px;
  }
`
const VerticalLine = styled.div`
  width: 1px;
  height: 16px;
  background-color: rgba(0, 0, 0, 0.3);
`
const TodayCloseButton = styled.button`
  color: #787878;
  text-decoration-line: underline;
`

const NowCloseButton = styled.button`
  color: #454545;
  font-weight: 700;
`
